// extracted by mini-css-extract-plugin
export default {"homeWrapper":"Home_homeWrapper__6Zy0M","home":"Home_home__CMw1J","headerText":"Home_headerText__Sp0iW","formWrapper":"Home_formWrapper__HlfIE"};